import React from 'react';
import { motion } from 'framer-motion';
const LIZA_IMG = 'https://cdn.magicpatterns.com/uploads/dbP8132HHUPJByzMHFSXeq/yo.jpg';
export function AboutLiza() {
  return <section className="w-full bg-[#f3e9dd] px-6 py-16 sm:py-24" data-id="element-13" data-mp="2u5auyu0tw5nu">
      <div className="mx-auto grid max-w-4xl items-center gap-10 md:grid-cols-2" data-id="element-14" data-mp="2u512mzsb9mez">
        <motion.div initial={{
        opacity: 0,
        x: -24
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.7
      }} className="order-2 md:order-1" data-id="element-15" data-mp="2y5kxfwpewdxy">
          <p className="mb-4 text-xs uppercase tracking-[0.3em] text-[#b06a4a]" data-id="element-16" data-mp="2ahbfj5vbkac3">
            Por qué escribí esta guía
          </p>
          <h2 className="font-serif text-2xl font-medium leading-snug text-[#3a2e28] sm:text-3xl" data-id="element-17" data-mp="2fhg13ab33v96">
            Lo viví contigo.
          </h2>
          <div className="mt-6 space-y-4 text-base leading-relaxed text-[#5c4d44]" data-id="element-18" data-mp="21iq1no0sljhn">
            <p data-id="element-19" data-mp="26ewz0sf4hmnz">
              Desde mi ventana, en el mismo país, con el mismo miedo. Soy Liza, y
              desde <span className="font-semibold text-[#3a2e28]" data-id="element-20" data-mp="284di71evwcij">Tu Mundo Equilibrado</span> acompaño
              a familias venezolanas en su bienestar emocional y espiritual.
            </p>
            <p data-id="element-21" data-mp="2i3uljc6nyebc">
              Pero después del 24 de junio sentí que no podía quedarme callada.
              Esta guía no es de una experta hablándote desde lejos. Es de alguien
              que también sintió la tierra moverse, que también abrazó a los suyos
              con miedo, y que eligió buscar la paz adentro cuando afuera todo era
              incertidumbre.
            </p>
            <p className="font-serif text-lg italic text-[#8f5238]" data-id="element-22" data-mp="1z733f62uy58v">
              La escribí porque quería poner mi granito de arena. Para ti. Para
              todos nosotros.
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 24
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.7
      }} className="order-1 md:order-2" data-id="element-23" data-mp="16murab0r9peo">
          <div className="overflow-hidden rounded-2xl shadow-xl shadow-[#8f5238]/10" data-id="element-24" data-mp="36qf8k8gchhth">
            <img src={LIZA_IMG} alt="Liza, de Tu Mundo Equilibrado, al atardecer frente a un paisaje de montaña" className="h-full w-full object-cover" data-id="element-25" data-mp="3bhx94veghgdx" />
          </div>
        </motion.div>
      </div>
    </section>;
}